import { doublePrecision, foreignKey, pgTable, uuid } from "drizzle-orm/pg-core";
import { list, listItem } from "../../common/list/list.sql";
import { foodServing } from "../food/food.sql";
import { relations } from "drizzle-orm";
import { mealPlan } from "../meal-plan/meal-plan.sql";

export const shoppingList = pgTable("shopping_list", {
  id: uuid("id")
    .primaryKey()
    .references(() => list.id),
  mealPlanId: uuid("meal_plan_id").references(() => mealPlan.id),
});

export const shoppingListRelations = relations(shoppingList, ({ one, many }) => ({
  base: one(list, {
    fields: [shoppingList.id],
    references: [list.id],
  }),
  items: many(shoppingListFoodItem),
}));

// Shopping list food items keep only a serving snapshot reference for historical identity.
export const shoppingListFoodItem = pgTable(
  "shopping_list_food_item",
  {
    id: uuid("id").primaryKey(),
    shoppingListId: uuid("shopping_list_id")
      .notNull()
      .references(() => shoppingList.id),
    foodServingId: uuid("food_serving_id")
      .notNull()
      .references(() => foodServing.id),
    amount: doublePrecision("amount").notNull(),
  },
  (t) => [
    foreignKey({
      name: "shopping_list_food_item_base_fk",
      columns: [t.shoppingListId, t.id],
      foreignColumns: [listItem.listId, listItem.id],
    }),
  ],
);

export const shoppingListFoodItemRelations = relations(shoppingListFoodItem, ({ one }) => ({
  shoppingList: one(shoppingList, {
    fields: [shoppingListFoodItem.shoppingListId],
    references: [shoppingList.id],
  }),
  base: one(listItem, {
    fields: [shoppingListFoodItem.id],
    references: [listItem.id],
  }),
  serving: one(foodServing, {
    fields: [shoppingListFoodItem.foodServingId],
    references: [foodServing.id],
  }),
}));
